export default __webpack_public_path__ + "static/mistake-2-a27aa1e32d9749eb257928b77ec5197e.png";